import { defaultTransformFn, dsApi } from "api/rtkQueryApi/DsApi";
import { Commission } from "../entities/Commission";
import { CommissionRateByCommissionPlan } from "../entities/CommissionRateByCommissionPlan";
import moment from "moment";

const commissionsTags = dsApi.enhanceEndpoints({
  addTagTypes: [
    "Commissions",
    "MyCommissions",
    "MyCurrentCommissionRate",
    "CurrentCommissionRateByEmail",
  ],
});

const commissionsApi = commissionsTags.injectEndpoints({
  endpoints: (build) => ({
    commissionsGetAll: build.query<Commission[], void>({
      query: () => {
        return {
          url: `commissions`,
          method: "GET",
        };
      },
      transformResponse: defaultTransformFn,
      providesTags: () => [{ type: "Commissions" }],
    }),
    commissionsGetMine: build.query<Commission[], void>({
      query: () => {
        return {
          url: `commissions/mine`,
          method: "GET",
        };
      },
      transformResponse: defaultTransformFn,
      providesTags: () => [{ type: "MyCommissions" }],
    }),
    commissionsGetBySalesEmail: build.query<
      Commission[],
      { salesEmail: string }
    >({
      query: ({ salesEmail }) => {
        return {
          url: `commissions/salesEmail/${salesEmail}`,
          method: "GET",
        };
      },
      transformResponse: defaultTransformFn,
      providesTags: (result, _, request) => [
        { type: "Commissions", id: request.salesEmail },
      ],
    }),
    commissionCreate: build.mutation<Commission, { commission: Commission }>({
      query: ({ commission }) => {
        return {
          url: `commissions`,
          method: "POST",
          body: commission,
        };
      },
      transformResponse: defaultTransformFn,
      invalidatesTags: () => [{ type: "Commissions" }],
    }),
    getMyCurrentCommissionRate: build.query<
      CommissionRateByCommissionPlan[],
      { forMonth: moment.Moment }
    >({
      query: ({ forMonth }) => {
        return {
          url: `commissions/mine/currentCommissionRate?forMonth=${forMonth.format()}`,
          method: "GET",
        };
      },
      transformResponse: defaultTransformFn,
      providesTags: (_1, _2, request) => [
        { type: "MyCurrentCommissionRate", id: request.forMonth.format() },
      ],
    }),
    getCurrentCommissionRateForEmail: build.query<
      CommissionRateByCommissionPlan[],
      { email: string; forMonth: moment.Moment }
    >({
      query: ({ email, forMonth }) => {
        return {
          url: `commissions/salesEmail/${email}/currentCommissionRate?forMonth=${forMonth.format()}`,
          method: "GET",
        };
      },
      transformResponse: defaultTransformFn,
      providesTags: (_1, _2, request) => [
        {
          type: "CurrentCommissionRateByEmail",
          id: `${request.email}|${request.forMonth.format()}`,
        },
      ],
    }),
  }),
});

export const {
  useCommissionsGetAllQuery,
  useCommissionsGetMineQuery,
  useCommissionsGetBySalesEmailQuery,
  useCommissionCreateMutation,
  useGetMyCurrentCommissionRateQuery,
  useGetCurrentCommissionRateForEmailQuery,
} = commissionsApi;
